import { SearchOutlined } from '@ant-design/icons'
import { AutoComplete } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeInputSearchStock } from 'store/actionReducers/StocksAnalysisStore';
import { getDetailStock } from 'store/actionReducers/TrendStore';

export default function SearchInput({ hiddenMobile = false }: { hiddenMobile: boolean }) {
  const dispatch = useDispatch();
  const CommnonStore = useSelector((state: any) => state?.CommnonStore)
  const [valueSearch, setValueSearch] = useState({ value: '' })
  const CompanyStore = useSelector((state: any) => state?.CompanyStore)
  const [openAutocomplete, setOpenAutocomplete] = useState(false)
  const itemAuto = useRef<any>();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    if (valueSearch?.value) {
      dispatch(getDetailStock({
        step: 'code', data: {
          stock: valueSearch?.value
        }
      }))
    }
  }, [valueSearch?.value])


  const onSelect = (data: string) => {
    // console.log('onSelect', data);
    setOpenAutocomplete(false)
    if (itemAuto?.current) {
      itemAuto.current.blur()
    }
    setValueSearch({ value: data })
  };

  const onSearch = (searchText: string) => {
    let obj: any = [];
    if (CompanyStore?.allCompany) {
      CompanyStore?.allCompany.filter((item: any) => {
        const code = item.code;
        const organname = item.organname;
        const exchange = item.exchange;
        const textSearch = searchText ? searchText : ''

        if (code && searchText &&
          ((code.toLowerCase()).indexOf(textSearch.toLowerCase()) > -1
            // ||
            // (organname.toLowerCase()).indexOf(textSearch.toLowerCase()) > -1 ||
            // (exchange.toLowerCase()).indexOf(textSearch.toLowerCase()) > -1
          )) {
          obj.push({ value: code, label: `${code} - ${organname} - ${exchange}` })
        }
      });
    }

    setOptions([...obj])
  };

  return (
    <>
      <div className={`rwjyzwhebo ${hiddenMobile ? 'lnempknegj' : 'rlmqsyvyzu'}`}>
        <div className='tpfrzmmcxq'>
          <AutoComplete
            ref={itemAuto}
            open={openAutocomplete}
            placement={CommnonStore?.innerWidthScreen < 700 ? "bottomLeft" : "bottomRight"}
            options={options}
            defaultActiveFirstOption={true}
            onFocus={() => setOpenAutocomplete(true)}
            onBlur={() => setOpenAutocomplete(false)}
            onSelect={onSelect}
            onSearch={onSearch}
            className='ewsfrgilzs'
            placeholder="Tìm kiếm"
            defaultValue={valueSearch?.value}
          />
          {/* <input className='ewsfrgilzs' placeholder='Tìm kiếm' /> */}
        </div>
        <div className='xspzedpfio'><SearchOutlined /></div>
      </div>
    </>
  )
}